module.exports = __webpack_public_path__ + "static/media/ico_firmaya_desktop_gris.151e90c9.svg";